import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ConfirmModalBody.module.css';

export type ConfirmModalBodyProps = ComponentProps<'div'>;

export const ConfirmModalBody: FunctionComponent<ConfirmModalBodyProps> =
  React.memo((props) => {
    const { children, className, ...remainingProps } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.body)}
      >
        {children}
      </div>
    );
  });
